import { render, staticRenderFns } from "./Buttongroup.vue?vue&type=template&id=3f89d594&scoped=true&"
import script from "./Buttongroup.vue?vue&type=script&lang=js&"
export * from "./Buttongroup.vue?vue&type=script&lang=js&"
import style0 from "./Buttongroup.vue?vue&type=style&index=0&id=3f89d594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f89d594",
  null
  
)

export default component.exports